import axios from "../utils/axios";

export const setTaskDetailById = (id) => {
    return axios.get("/PlannedMaintenance/GetTaskDetailById?id=" + id);
};
export const getSameLevelListById = (equipmentId) => {
    return axios.get("/Equipment/GetSameLevelListById?equipmentId=" + equipmentId);
};
export const getbreakdownRootCause = () => {
    return axios.get("/BreakdownRootCause/GetList");
};
export const getPoolList = () => {
    return axios.get("/Pool/GetList");
};

export const getBreakdownReasonGroupList = () => {
    return axios.get("/BreakdownReasonGroup/GetList");
};
export const getBreakdownEffectList = () => {
    return axios.get("/BreakdownEffect/GetList");
};

export const getTechnicianListByPoolId = (poolId) => {
    return axios.get("/User/GetTechnicianListByPoolId?poolId=" + poolId);
};

export const plannedMaintenanceAssign = (data) => {
    return axios.post("/PlannedMaintenance/Assign?taskId=" + data.id + "&userCode=" + data.userID);
};

export const getPlannedMintenance = (data) => {
    return axios.post(`/PlannedMaintenance/${data.task}?taskId=` + data.id);
};

export const plannedMaintenanceCloaseComplete = (data) => {
    return axios.post(`/PlannedMaintenance/${data.task}`, data.data);
};

export const plannedMaintenancePause = (data) => {
    return axios.post("/PlannedMaintenance/Pause?taskId=" + data.id + "&pauseReasonId=" + data.selectedMaintenancePauseReasonCode + "&pauseReasonNote=" + data.maintenancePauseNote);
};

export const plannedMaintenanceUpdateTask = (data) => {
    return axios.post("/PlannedMaintenance/UpdateTask", data);
};
export const AddTechnician = (data) => {
    return axios.post("/PlannedMaintenance/AddTechnician?taskId=" + data.id + "&userCode=" + data.selectedFriend);
};
export const BreakdownReasonPlaceByGroupId = (data) => {
    return axios.get("/BreakdownReasonPlace/GetListByGroupId?breakdownGroupId=" + data);
};
export const BreakdownReasonDetail = (data) => {
    return axios.get("/BreakdownReasonDetail/GetListByPlaceId?breakdownReasonPlaceId=" + data);
};

export const getPlannedFiles = (id) => {
    return axios.get(`/PlannedMaintenance/${id}/Files`, { responseType: "arraybuffer" });
};

export const addPlannedFiles = (payload) => {
    return axios.post(`/PlannedMaintenance/${payload.plannedId}/Files`, payload.data);
};

export const MaintenancePauseReason = () => {
    return axios.get("/MaintenancePauseReason/GetList");
};

export const getTaskHistoryById = (data) => {
    return axios.get("/PlannedMaintenance/GetTaskHistoryById?id=" + data.id);
};

export const deleteTask = (data) => {
    return axios.post("PlannedMaintenance/DeleteTask?plannedMaintenanceOrderTaskId=" + data.id + `&deleteFutureTasks=${data.flag}`);
};

export const deletePlannedFiles = (payload) => {
    return axios.delete(`/PlannedMaintenance/${payload.plannedId}/Files`, { data: payload.fileNames });
};

export const getEkedEquipmentList = (id) => {
    return axios.get(`/PlannedMaintenance/GetEkedEquipmentList?id=${id}`);
};

export const updateEkedEquipmentList = (data) => {
    return axios.post(`/PlannedMaintenance/UpdateEkedEquipmentList?taskId=${data.taskId}&ekedUsed=${data.ekedUsed}`, data.payload);
};
